import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionKicker = ({ children }) => (
  <span
    className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-brand font-heading"
    data-testid="section-kicker"
  >
    <span className="h-px w-8 bg-brand" />
    {children}
  </span>
);
